import api from '../config/api';

/**
 * Get available limousine vehicle types
 */
export const getAvailableVehicles = async () => {
  try {
    const response = await api.get('/limousine/available-vehicles');
    return response.data;
  } catch (error) {
    console.error('Error fetching available vehicles:', error);
    throw error;
  }
};

/**
 * Book a limousine
 */
export const bookLimousine = async (bookingData) => {
  try {
    const response = await api.post('/limousine/book', bookingData);
    return response.data;
  } catch (error) {
    console.error('Error booking limousine:', error);
    throw error;
  }
};

/**
 * Get user's limousine bookings
 */
export const getMyLimousineBookings = async () => {
  try {
    const response = await api.get('/limousine/bookings');
    return response.data;
  } catch (error) {
    console.error('Error fetching bookings:', error);
    throw error;
  }
};

/**
 * Cancel a limousine booking
 */
export const cancelLimousineBooking = async (bookingId) => {
  try {
    const response = await api.patch(`/limousine/bookings/${bookingId}/cancel`);
    return response.data;
  } catch (error) {
    console.error('Error cancelling booking:', error);
    throw error;
  }
};

/**
 * Calculate estimated fare (client-side)
 */
export const calculateLimousineFare = (vehicleType, distance) => {
  const vehiclePricing = {
    'SEDAN': { base: 150, perMile: 3.5 },
    'EXECUTIVE_SUV': { base: 250, perMile: 4.5 },
    'STRETCH_LIMO': { base: 400, perMile: 6.0 },
    'LUXURY_SEDAN': { base: 200, perMile: 4.0 },
  };

  const pricing = vehiclePricing[vehicleType] || vehiclePricing['SEDAN'];
  return pricing.base + (distance * pricing.perMile);
};
